var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEVisitRepeat(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.03493 7C7.48053 7 7.03058 7.448 7.03058 8V11H12.0523C12.6067 11 13.0567 10.4997 13.0567 9.94775V9.9209C13.0567 9.3689 12.6067 9 12.0523 9H9.03929V8C9.03929 7.448 8.58933 7 8.03493 7ZM14.9881 10C14.4879 10 14.0711 10.3669 13.9998 10.8589C13.5207 14.1679 10.3198 16.6138 6.73632 15.8638C4.46246 15.3878 2.62349 13.557 2.14542 11.293C1.32888 7.42299 4.28769 4 8.03493 4V6L13.0567 3L8.03493 0V2C3.07042 2 -0.842528 6.48301 0.156802 11.605C0.765439 14.724 3.29037 17.2378 6.42295 17.8438C11.1695 18.7617 15.3697 15.516 15.9904 11.126C16.0748 10.53 15.5917 10 14.9881 10Z",
    fill: "#333D6C"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEVisitRepeat);
export default __webpack_public_path__ + "static/media/e_visit_repeat.e92317fd5ba0c500d1f60e785bf8846e.svg";
export { ForwardRef as ReactComponent };